const ActionTypes = {
  // Loader
  LOADER_SHOW: 'LOADER_SHOW',
  LOADER_HIDE: 'LOADER_HIDE',
  GET_OPTIONS: 'GET_OPTIONS',
  SET_HEADER_TITLE: 'SET_HEADER_TITLE',
};

export default ActionTypes;
